import { apiCall } from '../../../utils/apiCall';

export const trackItemView = async (itemID: string | number) =>
  apiCall({
    endpoint: `items/${itemID}/tracking/view_count`,
    method: 'POST',
    reshaper: (data: any) => data,
  });

export const trackItemAddToCart = async (itemID: string | number) =>
  apiCall({
    endpoint: `items/${itemID}/tracking/add_to_cart_count`,
    method: 'POST',
    reshaper: (data: any) => data,
  });
